
import Vue from 'vue'
import AuthModal from './AuthModal.vue'

export function showAuthModal(options = {}) {
  return new Promise((resolve, reject) => {
    const ModalConstructor = Vue.extend(AuthModal)

    const instance = new ModalConstructor({
      propsData: {
        title: options.title,
        contentLines: options.contentLines,
        cancelText: options.cancelText,
        confirmText: options.confirmText,
        remove: () => {
          if (instance.$el && instance.$el.parentNode) {
            document.body.removeChild(instance.$el)
          }
          instance.$destroy()
        },
        onConfirm: () => {
          resolve('verified')
        },
        onCancel: () => {
          reject('cancelled')
        }
      }
    })

    instance.$mount()

    document.body.appendChild(instance.$el)
  })
}
